export enum EFormMainElements {
  INPUT_BASE = "INPUT_BASE",
  ERROR_ELEMENTS = "ERROR_ELEMENTS",
}
